module.exports = __webpack_public_path__ + "static/media/macho-micronn.d5006bfb.svg";